





import { Vue, Component } from 'vue-property-decorator';

@Component
export default class GlobeAltSolid extends Vue {}
